export default "__VITE_PUBLIC_ASSET__203eeb83__"